module.exports = __webpack_public_path__ + "static/media/thief_girl-hiding.fbb3c155.svg";